import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import { Body2 } from 'components/Typography';
import { formatPercent } from '@dapp/multi-lib/lib/formatters';

type ChipAssetChangesProps = {
  percents: number;
};

export const ChipAssetChanges = ({ percents }: ChipAssetChangesProps) => {
  return (
    <div className='rounded-main inline-flex w-fit items-center gap-1 bg-white-300 px-0.5 py-2'>
      <div className='flex h-[33px] w-[33px] items-center justify-center rounded-full bg-black'>
        <Icon icon='arrow_curve' height={21} width={21} color='#9DB178' />
      </div>
      <Body2 className='pr-3 leading-[1.5rem] text-[#191A1E] lg:text-[1.5rem]'>
        {formatPercent(percents)}%
      </Body2>
    </div>
  );
};
